

import { makeStyles } from "@material-ui/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";


const drawerWidth = 60;

export default makeStyles((theme) => ({

    root: {
        display: 'flex',
    },
    appBar: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginRight: drawerWidth,
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    // necessary for content to be below app bar
    // toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
    },

    toolbar: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    hide: {
        display: "none",
    },
    grow: {
        flexGrow: 1,
    },
    search: {
        position: "relative",
        borderRadius: 25,
        paddingLeft: theme.spacing(2.5),
        width: 36,
        backgroundColor: fade(theme.palette.common.black, 0),
        transition: theme.transitions.create(["background-color", "width"]),
        "&:hover": {
            cursor: "pointer",
            backgroundColor: fade(theme.palette.common.black, 0.08),
        },
    },
    searchFocused: {
        backgroundColor: fade(theme.palette.common.black, 0.08),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: 250,
        },
    },
    searchIcon: {
        width: 36,
        right: 0,
        height: "100%",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: theme.transitions.create("right"),
        "&:hover": {
            cursor: "pointer",
        },
    },
    searchIconOpened: {
        right: theme.spacing(1.25),
    },
    inputRoot: {
        color: "inherit",
        width: "100%",
    },
    inputInput: {
        height: 36,
        padding: 0,
        paddingRight: 36 + theme.spacing(1.25),
        width: "100%",
    },
    messageContent: {
        display: "flex",
        flexDirection: "column",
    },
    headerMenu: {
        marginTop: theme.spacing(6),
        maxHeight: "400px",

    },
    headerMenuList: {
        display: "flex",
        flexDirection: "column",
    },
    headerMenuItem: {
        "&:hover, &:focus": {
            backgroundColor: theme.palette.primary.main,
            color: "white",
        },
    },
    headerMenuButton: {
        // marginLeft: theme.spacing(2),
        // padding: theme.spacing(0.5),

    },
    headerMenuButtonCollapse: {
        // marginRight: theme.spacing(2),
    },
    headerIcon: {
        fontSize: 28,
        // color: theme.appbar.text,
    },
    headerIconCollapse: {
        // color: theme.appbar.text,
    },
    large: {
        height: 60,
        width: 60
    },
    profileContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    profileMenu: {
        minWidth: 265,
    },
    profileMenuText: {
        display: "flex",
        flexDirection: "column",
        padding: theme.spacing(2),
        alignItems: 'center'
    },
    profileMenuUser: {
        display: "flex",
        flexDirection: "column",
        padding: theme.spacing(2),
    },
    profileMenuItem: {
        color: theme.palette.text.hint,
    },
    profileMenuIcon: {
        marginRight: theme.spacing(2),
        color: theme.palette.text.hint,
    },
    profileMenuLink: {
        fontSize: 16,
        textDecoration: "none",
        "&:hover": {
            cursor: "pointer",
        },
    },
    profileMenuIconSize: {
        // width: 30,
        // height: 30
    },
    messageNotification: {
        height: "auto",
        display: "flex",
        alignItems: "center",
        "&:hover, &:focus": {
            backgroundColor: theme.palette.background.light,
        },
    },
    messageNotificationSide: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginRight: theme.spacing(2),
    },
    messageNotificationBodySide: {
        alignItems: "flex-start",
        marginRight: 0,
    },
    sendMessageButton: {
        margin: theme.spacing(4),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textTransform: "none",
    },
    sendButtonIcon: {
        marginLeft: theme.spacing(2),
    },
    menuButtonIconClosed: {
        transition: theme.transitions.create(["transform"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        transform: "rotate(0deg)"
    },
    menuButtonIconOpen: {
        transition: theme.transitions.create(["transform"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        transform: "rotate(180deg)"
    },
    iconButtonCircular: {
        border: "1px solid",
        padding: '0px',
        margin: '5px',
        marginLeft: 'auto',
        marginRight: 'auto',
        height: '40px',
        width: '40px',
        backgroundColor: (theme.rightBarButtons.background + ' !important'),
        color: theme.rightBarButtons.text
    },
    iconButtonCircularActive: {
        border: "1px solid",
        padding: '0px',
        margin: '5px',
        marginLeft: 'auto',
        marginRight: 'auto',
        height: '40px',
        width: '40px',
        backgroundColor: (theme.rightBarButtonsActive.background + ' !important'),
        color: theme.rightBarButtonsActive.text
    }

}));
